import React, { useContext } from 'react'
import { ChangePresentContext, MedPlanContext } from '../../SingleEvent'
import { Grid } from '@mui/material'
import PresetsTextField from '../../../../../components/Forms/PresetsTextField'

const SpecialNotes = () => {
  const { medPlan, setMedPlan } = useContext(MedPlanContext)
  const { changesPresent, setChangesPresent } = useContext(ChangePresentContext)

  return (
    <Grid item xs={12} lg={6}>
      <PresetsTextField
        label="Special Clinical Notes"
        fullWidth
        multiline
        value={medPlan?.specialNotes}
        suggestionPath="medPlan.specialNotes"
        suggestionLabel="Special clinical notes from templates"
        setValue={(newValue) => {
          setMedPlan((prev) => ({
            ...prev,
            specialNotes: newValue,
          }))
          !changesPresent && setChangesPresent(true)
        }}
        InputLabelProps={{
          shrink: !!medPlan?.specialNotes,
        }}
        autoComplete="off"
        name="medplan-specialnotes"
      />
    </Grid>
  )
}

export default React.memo(SpecialNotes)
